module.exports = __webpack_public_path__ + "static/media/24UHCHR3.2536457a.jpg";